import { SOCIAL_PLATFORMS_NAMES } from '~/constants';

import { NavigationLink } from './components/NavBar/components/ShareNavBar/ShareNavBar.model';

export const COUNTRY_TOOLTIP_MESSAGE =
  "Percentage of the creator's audience who are from these countries.";

export const GENDER_TOOLTIP_MESSAGE =
  "Percentage of the creator's audience who are female and male.";

export const AGE_TOOLTIP_MESSAGE =
  "Percentage of the creator's audience who are in each age bracket.";

export const OVERALL_REACH_SECTION_ID = 'profile';
export const INSTAGRAM_SECTION_ID = 'instagram';
export const TIKTOK_SECTION_ID = 'tiktok';
export const YOUTUBE_SECTION_ID = 'youtube';

export const NAVIGATION_LINKS: NavigationLink[] = [
  { href: `#${OVERALL_REACH_SECTION_ID}`, label: 'Profile' },
  { href: `#${INSTAGRAM_SECTION_ID}`, label: SOCIAL_PLATFORMS_NAMES.instagram },
  { href: `#${TIKTOK_SECTION_ID}`, label: SOCIAL_PLATFORMS_NAMES.tiktok },
  { href: `#${YOUTUBE_SECTION_ID}`, label: SOCIAL_PLATFORMS_NAMES.youtube },
];
